import React from "react";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import thumb1 from '@images/realizations/13/thumbs/13_1.webp';
import thumb2 from '@images/realizations/13/thumbs/13_2.webp';
import thumb3 from '@images/realizations/13/thumbs/13_3.webp';
import thumb4 from '@images/realizations/13/thumbs/13_4.webp';
import thumb5 from '@images/realizations/13/thumbs/13_5.webp';
import thumb6 from '@images/realizations/13/thumbs/13_6.webp';
import thumb7 from '@images/realizations/13/thumbs/13_7.webp';
import thumb8 from '@images/realizations/13/thumbs/13_8.webp';
import thumb9 from '@images/realizations/13/thumbs/13_9.webp';
import thumb10 from '@images/realizations/13/thumbs/13_10.webp';
import thumb11 from '@images/realizations/13/thumbs/13_11.webp';
import thumb12 from '@images/realizations/13/thumbs/13_12.webp';
import thumb13 from '@images/realizations/13/thumbs/13_13.webp';
import thumb14 from '@images/realizations/13/thumbs/13_14.webp';
import thumb15 from '@images/realizations/13/thumbs/13_15.webp';
import thumb16 from '@images/realizations/13/thumbs/13_16.webp';
import thumb17 from '@images/realizations/13/thumbs/13_17.webp';
import thumb18 from '@images/realizations/13/thumbs/13_18.webp';
import thumb19 from '@images/realizations/13/thumbs/13_19.webp';
import thumb20 from '@images/realizations/13/thumbs/13_20.webp';
import thumb21 from '@images/realizations/13/thumbs/13_21.webp';
import thumb22 from '@images/realizations/13/thumbs/13_22.webp';
import thumb23 from '@images/realizations/13/thumbs/13_23.webp';
import thumb24 from '@images/realizations/13/thumbs/13_24.webp';
import thumb25 from '@images/realizations/13/thumbs/13_25.webp';
import thumb26 from '@images/realizations/13/thumbs/13_26.webp';
import full1 from '@images/realizations/13/full/13_1.webp';
import full2 from '@images/realizations/13/full/13_2.webp';
import full3 from '@images/realizations/13/full/13_3.webp';
import full4 from '@images/realizations/13/full/13_4.webp';
import full5 from '@images/realizations/13/full/13_5.webp';
import full6 from '@images/realizations/13/full/13_6.webp';
import full7 from '@images/realizations/13/full/13_7.webp';
import full8 from '@images/realizations/13/full/13_8.webp';
import full9 from '@images/realizations/13/full/13_9.webp';
import full10 from '@images/realizations/13/full/13_10.webp';
import full11 from '@images/realizations/13/full/13_11.webp';
import full12 from '@images/realizations/13/full/13_12.webp';
import full13 from '@images/realizations/13/full/13_13.webp';
import full14 from '@images/realizations/13/full/13_14.webp';
import full15 from '@images/realizations/13/full/13_15.webp';
import full16 from '@images/realizations/13/full/13_16.webp';
import full17 from '@images/realizations/13/full/13_17.webp';
import full18 from '@images/realizations/13/full/13_18.webp';
import full19 from '@images/realizations/13/full/13_19.webp';
import full20 from '@images/realizations/13/full/13_20.webp';
import full21 from '@images/realizations/13/full/13_21.webp';
import full22 from '@images/realizations/13/full/13_22.webp';
import full23 from '@images/realizations/13/full/13_23.webp';
import full24 from '@images/realizations/13/full/13_24.webp';
import full25 from '@images/realizations/13/full/13_25.webp';
import full26 from '@images/realizations/13/full/13_26.webp';

const images = [
    {
        thumbnail: thumb1,
        original: full1
    },
    {
        thumbnail: thumb2,
        original: full2
    },
    {
        thumbnail: thumb3,
        original: full3
    },
    {
        thumbnail: thumb4,
        original: full4
    },
    {
        thumbnail: thumb5,
        original: full5
    },
    {
        thumbnail: thumb6,
        original: full6
    },
    {
        thumbnail: thumb7,
        original: full7
    },
    {
        thumbnail: thumb8,
        original: full8
    },
    {
        thumbnail: thumb9,
        original: full9
    },
    {
        thumbnail: thumb10,
        original: full10
    },
    {
        thumbnail: thumb11,
        original: full11
    },
    {
        thumbnail: thumb12,
        original: full12
    },
    {
        thumbnail: thumb13,
        original: full13
    },
    {
        thumbnail: thumb14,
        original: full14
    },
    {
        thumbnail: thumb15,
        original: full15
    },
    {
        thumbnail: thumb16,
        original: full16
    },
    {
        thumbnail: thumb17,
        original: full17
    },
    {
        thumbnail: thumb18,
        original: full18
    },
    {
        thumbnail: thumb19,
        original: full19
    },
    {
        thumbnail: thumb20,
        original: full20
    },
    {
        thumbnail: thumb21,
        original: full21
    },
    {
        thumbnail: thumb22,
        original: full22
    },
    {
        thumbnail: thumb23,
        original: full23
    },
    {
        thumbnail: thumb24,
        original: full24
    },
    {
        thumbnail: thumb25,
        original: full25
    },
    {
        thumbnail: thumb26,
        original: full26
    },
];

const ProjectSinglePage = () => {
    const [open, setOpen] = React.useState(false);
    const [currentIndex, setCurrentIndex] = React.useState(0);

    const handleImageClick = (index) => {
        setCurrentIndex(index);
        setOpen(true);
    };

    return (
        <div className="property-single mt-150">
            <div className="container">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="property-single-left" style={{backgroundImage: `url(${images[3].original})`}}>
                            
                            <div className="property-left-content">   
                                <h3>Realizacja 13  <span className="font-weight-light"></span></h3>
                                <ul>
                                    <li>podłoga drewniana</li>
                                    <li>deska trójwarstwowa</li>
                                    <li>schody drewniane</li>
                                    <li>Kraków</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="property-single-right">
                            <div className="property-right-content pl-40 rpl-0">
                               
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12 col-lg-12">
                        <div className="instagram-posts pt-100">
                            {images.map((item, index) => (
                                <div className="instagram-item" key={index}>
                                    <img src={item.thumbnail} alt="Instagram" onClick={() => handleImageClick(index)} />
                                    <div className="instagram-overlay">
                                        <span onClick={() => handleImageClick(index)}><i className="fa fa-plus"></i></span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <Lightbox
                open={open}
                index={currentIndex}
                close={() => setOpen(false)}
                slides={images.map((img) => ({ src: img.original }))}
                plugins={[Zoom]}
            />
        </div>
    );
};

export default ProjectSinglePage;